import { compose, withProps } from 'recompose';
import EventDetails from './event-details';

export default compose(
  withProps(
    () => ({
      duplicate: true
    })
  )
)(EventDetails);


// WEBPACK FOOTER //
// ./src/containers/pages/publisher-portal/event-duplicate.js